import React, { useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { getDoc, doc } from "firebase/firestore";
import { firebaseAuth } from "./firebase/firebase_configuration";
import { firebaseFirestore } from "./firebase/firebase_configuration";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSearchContext } from "./chats/searchContext";
import Logout from "./authentication/logout";
import "../styles/sideNavBar.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import profileImage from "../images/authentication/no_profile.png";
import logoutImage from "../images/logout_image.png";
import activeHomeIcon from "../images/home/home_icon/active_home.png";
import inactiveHomeIcon from "../images/home/home_icon/inactive_home.png";
import activeChatIcon from "../images/home/chat_icon/active_chat.png";
import inactiveChatIcon from "../images/home/chat_icon/inactive_chat.png";
import activeCollectionIcon from "../images/home/collection_icon/active_collection.png";
import inactiveCollectionIcon from "../images/home/collection_icon/inactive_collection.png";
import activeSearchIcon from "../images/home/active_search_icon.png";
import inactiveSearchIcon from "../images/chats/search_icon.png";
import activeProfileIcon from "../images/home/profile_icon/active_profile.png";
import inactiveProfileIcon from "../images/home/profile_icon/inactive_profile.png";
import activeVoteIcon from "../images/vote/active_vote_b.png";
import inactiveVoteIcon from "../images/vote/inactive_vote_b.png";
import activeSupportIcon from "../images/support/active_support.png";
import inactiveSupportIcon from "../images/support/inactive_support.png";

const Sidebar = () => {
  const goTo = useNavigate();
  const location = useLocation();
  const {getUnknownTab, setYourId} = useSearchContext();
  const [showSidebar, setShowSidebar] = useState(false);
  const [activeLink, setActiveLink] = useState("home");
  const [isLogoutShow, setLogoutShow] = useState(false);
  const [getUsername, setUsername] = useState("");
  const [getUserImage, setUserImage] = useState("");

  const onLogout = () => {
    setLogoutShow(true);
  };

  const getUserDetails = async (id) => {
    try {
      const userRef = doc(firebaseFirestore, "User Details", id);
      const userSnapshot = await getDoc(userRef);

      if (userSnapshot.exists()) {
        setUsername(userSnapshot.data().username);
        setUserImage(userSnapshot.data().image || "");
      }
    } catch (error) {
      console.log(`${error.message}; User Id: ${id}`);
    }
  };

  useEffect (() => {
    const isLoggedIn = onAuthStateChanged(firebaseAuth, (user) => {
      if (!user) {
        goTo("/login", {replace: true});
      }else{
        setYourId(user.uid);
        getUserDetails(user.uid); 
      };
    });

    return () => isLoggedIn();
  }, [goTo, setYourId]);

  useEffect(() => {
    if (getUnknownTab === "unknown") {
      setActiveLink(getUnknownTab);
    } else {
      const path = location.pathname.split("/")[location.pathname.split("/").indexOf("main_back") + 1]; 
      setActiveLink(path);
    }
  }, [location, getUnknownTab]);

  const handleClick = (linkId) => {
    setActiveLink(linkId);
  };

  const toggleSidebar = () => setShowSidebar(!showSidebar);

  return (
    <div className="d-flex" id="wrapper">
      <button
        className="btn btn-primary d-block d-md-none"
        onClick={toggleSidebar}
        style={{
          position: "fixed",
          top: 10,
          left: 10,
          zIndex: 101,
          backgroundColor: "black",
        }}
      >
        {" "}
        ☰{" "}
      </button>

      <div
        className={`text-white ${showSidebar ? "show" : ""}`}
        id="sidebar"
        // style={{ backgroundColor: "rgba(0, 0, 0, 0.3)" }}
        style={{ backgroundColor: "#030A1A" }}
      >
        <div
          className="sidebar-header text-center p-3"
          style={{
            backgroundColor: "black",
          }}
        >
          <Link style={{color: "white", textDecoration: "none"}} to="/main_back/home"><h4>Movinity</h4></Link>
        </div>

        <div className="profile">
          <img src={getUserImage === "" || getUserImage === null ? profileImage : getUserImage} alt="profile" />
        </div>

        <h6 className="profile_name">@{getUsername}</h6>

        <div className="divder"></div>

        <div className="list-group">
          <Link
            to="/main_back/home"
            className="list-group-item list-group-item-action bg-dark text-white"
            id={["home", "28", "53", "9648", "10751", "27", "35"].includes(activeLink) 
              ? "click" 
              : ""}
            onClick={() => handleClick("home")}
          >
            <img alt="home" src={["home", "28", "53", "9648", "10751", "27", "35"].includes(activeLink)
              ? activeHomeIcon 
              : inactiveHomeIcon} className="list-group-icons" />
            Home
          </Link>
          {/* <Link
            to="/main_back/posts"
            className="list-group-item list-group-item-action bg-dark text-white"
            id={activeLink === "posts" ? "click" : ""}
            onClick={() => handleClick("posts")}
          >
            <img src={activeLink === "posts" ? activePostIcon : inactivePostIcon} className="list-group-icons" />
            Posts
          </Link> */}
          <Link
            to="/main_back/chats"
            className="list-group-item list-group-item-action bg-dark text-white"
            id={activeLink === "chats" ? "click" : ""}
            onClick={() => handleClick("chats")}
          >
            <img alt="chats" src={activeLink === "chats" ? activeChatIcon : inactiveChatIcon} className="list-group-icons" />
            Chats
          </Link>

          <Link
            to="/main_back/collections"
            className="list-group-item list-group-item-action bg-dark text-white"
            id={activeLink === "collections" ? "click" : ""}
            onClick={() => handleClick("collections")}
          >
            <img alt="collections" src={activeLink === "collections" ? activeCollectionIcon : inactiveCollectionIcon} className="list-group-icons" />
            Collections
          </Link>

          <Link
            to="/main_back/search"
            className="list-group-item list-group-item-action bg-dark text-white"
            id={activeLink === "search" ? "click" : ""}
            onClick={() => handleClick("search")}
          >
            <img alt="search" src={activeLink === "search" ? activeSearchIcon : inactiveSearchIcon} className="list-group-icons" />
            Search
          </Link>

          <Link
            to="/main_back/profile"
            className="list-group-item list-group-item-action bg-dark text-white"
            id={activeLink === "profile" ? "click" : ""}
            onClick={() => handleClick("profile")}
          >
            <img alt="profile" src={activeLink === "profile" ? activeProfileIcon : inactiveProfileIcon} className="list-group-icons" />
            Profile
          </Link>

          <Link
            to="/main_back/vote"
            className="list-group-item list-group-item-action bg-dark text-white"
            id={activeLink === "vote" ? "click" : ""}
            onClick={() => handleClick("vote")}
          >
            <img alt="vote" src={activeLink === "vote" ? activeVoteIcon : inactiveVoteIcon} className="list-group-icons" />
            Vote
          </Link>

          <Link
            to="/main_back/support"
            className="list-group-item list-group-item-action bg-dark text-white"
            id={activeLink === "support" ? "click" : ""}
            onClick={() => handleClick("support")}
          >
            <img alt="support" src={activeLink === "support" ? activeSupportIcon : inactiveSupportIcon} className="list-group-icons" />
            Support
          </Link>

          <div className="list-group-item_logout list-group-item-action bg-dark text-white" onClick={() => onLogout()} >
            <img src={logoutImage} alt="logout" className="list-group-icons_logout" />
            Log out
          </div>
        </div>

        {/* <div className="logout" onClick={() => onLogout()} >
          <img src={logoutImage} alt="logout" />
          <h5>Log out</h5>
        </div> */}
        {isLogoutShow && <Logout isLogoutShow={isLogoutShow} setLogoutShow={setLogoutShow} />}
      </div>
    </div>
  );
};

export default Sidebar;